import { Injectable } from "@angular/core";
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class Msg {

  successCall(msg: string, titulo: string, callback: any) {
    const title = titulo == null ? 'Éxito' : titulo
    Swal.fire({
      title: title,
      text: msg,
      buttonsStyling: false,
      customClass: {
        confirmButton: 'btn btn-success'
      },
      confirmButtonText: 'Aceptar',
      icon: 'success'
    }).then(callback).catch(() => { });
  }

  warningCall(msg: string, titulo: string, callback: any) {
    const title = titulo == null ? 'Revisa esto...' : titulo
    Swal.fire({
      title: title,
      text: msg,
      buttonsStyling: false,
      customClass: {
        confirmButton: 'btn  btn-finan-cuatro'
      },
      confirmButtonText: 'Aceptar',
      icon: 'warning',
      allowOutsideClick: false 
    }).then(callback);

  }

  errorCall(msg: string, titulo: string, callback: any) {
    const title = titulo == null ? 'Error...' : titulo
    Swal.fire({
      title: title,
      text: msg,
      buttonsStyling: false,
      customClass: {
        confirmButton: 'btn btn-error'
      },
      confirmButtonText: 'Aceptar',
      icon: 'error',
      allowOutsideClick: false 
    }).then(callback).catch(() => { });
  }

  infoCall(msg: string, titulo: string, callback: any) {
    const title = titulo == null ? 'Información...' : titulo
    Swal.fire({
      title: title,
      text: msg,
      buttonsStyling: false,
      customClass: {
        confirmButton: 'btn btn-success'
      },
      confirmButtonText: 'Aceptar',
      icon: 'info'
    }).then(callback);
  }

  questionCall(msg: string, titulo: string, callback: any) {
    const title = titulo

    Swal.fire({
      title: title,
      text: msg,
      buttonsStyling: true,
      showConfirmButton: true,
      showCancelButton: true,
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-finan-tres',
      },
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
      allowEscapeKey: true,
      icon: 'question',
      allowOutsideClick: false 
    }).then((result) => { if (result.value) { callback() } })

  }

  inputCall(msg: string, titulo: string, callback: any) {

  }

  //Messages with timen
  succTime(msg: string, titulo: string, callback: any) {
    const title = titulo == null ? 'Exitoso...' : titulo
    Swal.fire({
      icon: 'success',
      title: title,
      text: msg,
      showConfirmButton: false,
      timer: 1100
    }).then(callback)

  }

  warningCallRegistros2(msg: string, titulo: string, callback: any) {
    const title = titulo == null ? 'Sin registros para mostrar' : titulo
    Swal.fire({
      title: title,
      text: msg,
      buttonsStyling: false,
      icon: 'warning',
      showConfirmButton: false,
      timer: 1000
    }).catch().then(callback);
  }
}